import { Stack } from "@mui/material";
import { useContext } from "react";

import TextInputField from "./components/TextInputField";
import Context from "./context";

// ----------------------------------------------------------------------

export const EntitiesSearchInput = () => {
	const { actions, state } = useContext(Context);

	return (
		<Stack flexDirection={"row"} alignItems={"center"} sx={{ mt: 2, mb: 1, ml: 0.4 }}>
			<TextInputField
				value={state.filterName}
				label={"Busca tu entidad"}
				onChange={actions.onChangeFilter}
			/>
		</Stack>
	);
};

export default EntitiesSearchInput;
